import React from 'react'
import { Field } from 'formik'
import Input from '../Input'
import Column from './Column'

export default ({
  baseName,
  onChange,
  ...rest,
}) => (
  <Column>
    <Field name={`${baseName}.value`}>
      {({ field }) => (
        <Input
          {...rest}
          {...field}
          onChange={onChange(field)}
        />
      )}
    </Field>
  </Column>
)
